import React from 'react';
import {getSystem, TypeImplementation} from '@packages/systems/wfdl';
import {
  ExpressionEditor,
  updateExpressionAction,
} from '@packages/systems/ExpressionEditor-utils';
import {useTheme} from '@packages/utilities/styled';

import {TBoolean, EBoolean} from '@packages/systems/wfdl-ast';

import {
  ContextualExpressions,
  stripAnn,
  getAnn,
} from '@packages/utilities/contextual-expression';

const ReverseLabelBoolean = TypeImplementation.Alias({
  type: TBoolean,
  render: ({expr, dispatch}) => {
    const {type} = getAnn(expr);

    const system = type ? getSystem(type) : null;

    const exprValue = ContextualExpressions.getBoolean(stripAnn(expr));

    const toggle = () => {
      dispatch(updateExpressionAction(EBoolean(!exprValue || false)));
    };

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {gutters, control} = useTheme();

    return (
      <div
        style={{
          height: control.height,
          gridColumn: '1 / -1',
          display: 'flex',
          gap: gutters.x8,
          alignItems: 'center',
        }}
      >
        <ExpressionEditor expression={expr} dispatch={dispatch} />
        <span
          onClick={toggle}
          onKeyDown={toggle}
          role="checkbox"
          aria-checked={exprValue || false}
          tabIndex={0}
          style={{lineHeight: 1}}
        >
          {(system && system.label) || ''}
        </span>
      </div>
    );
  },
});

export default ReverseLabelBoolean;
